import React from 'react';
import './ContactInfo.css';



const ContactInfo = ({ contactContent }) => {

  return (
    <div className='contact-info-container'>

      {/* Loop through the contact array and display each contact info item */}
      {contactContent.map((contact) => (
        <div className='info-item' key={contact.id}>

          {/* Display the contact icon */}
          <div className='icon'>{contact.icon}</div>

          {/* Display the contact title and details */}
          <div className='content'>
            <h3>{contact.title}</h3>
            {/* Loop through the content array and display each item as a paragraph */}
            {contact.content.map((value, index) => (
              <p key={index}>{value}</p>
            ))}
          </div>

        </div>
      ))}
    </div>
  );

};

export default ContactInfo;